import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icn-faq",
  "use": "icon-icn-faq-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-icn-faq\"><g fill-rule=\"evenodd\" stroke=\"#8695a1\" stroke-width=\"1.5\"><circle cx=\"12\" cy=\"12\" r=\"11.25\" /><g stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M9 9a3 3 0 114 2.829 1.5 1.5 0 00-1 1.415v1.006M12 17.25a.375.375 0 100 .75.375.375 0 000-.75z\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol